import apiClient from '../apiClient'

export const fetchOutlets = async (regionId?: number) => {
  const { data } = await apiClient.get(`/api/outlets${regionId ? `?region_id=${regionId}` : ''}`)
  return data
}
